import account from "./account";
import device from "./device";
import devices from "./devices";
import dos from "./dos";
import requests from "./requests";

export default {
  state: {},
  namespaced: true,
  modules: {
    account,
    device,
    devices,
    dos,
    requests,
  },
};
